import { cn } from '@/lib/utils';

interface DataSourceIconProps {
  iconURL?: string | null;
  name: string;
  className?: string;
  'data-testid'?: string;
}

export const DataSourceIcon = ({
  iconURL,
  name,
  className,
  'data-testid': testId,
}: DataSourceIconProps) => {
  return (
    <img
      className={cn('object-contain', className)}
      src={iconURL ?? '/images/default_icon.png'}
      alt={name ?? ''}
      data-testid={testId}
    />
  );
};
